@import 'styles/mixins';
@import 'styles/blaze/mixins';
@import 'styles/variables';

.wrapper {
  position: relative;
  width: 100%;
  min-height: 400px;
  max-height: 800px;

  svg {
    display: block;
    margin: 0 auto;
  }
}

.loadingOverlay {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(255, 255, 255, 0.75);
}

.loadingText {
  color: var(--dark-60);
}

.error {
  color: var(--red-60);
  padding: 1rem;
  text-align: center;
}

.tooltip {
  background: white;
  padding: 0.5rem;
  border-radius: 0.5rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.tooltipSection {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}
